import {Injectable} from '@angular/core';

@Injectable()
export class NetworkInformationService {

  private online : boolean =  true;

  constructor() {
  }

  public setOnline(online:boolean) {
    this.online = online;
  }

  public getOnline() {
    return this.online;
  }
}



// WEBPACK FOOTER //
// ./src/providers/network.information.service.ts